import { nsSelector } from '../../../../../utils/redux';
import { getItemState } from '../../../../../utils/store/state/state';

const userSelector = nsSelector('user');

export const profile = userSelector('profile');

//DEPRECATED
export const userProfile = userSelector('userProfile');
